import { Box, Button, Container, Typography } from "@mui/material";

import { FaArrowRight, FaTag, FaTshirt, FaUserTie } from "react-icons/fa";

import pricingBg from "../../assets/images/pricing_bg.png";
import pricingBgM from "../../assets/images/pricing_bg_m.png";

// import pricingCardBg from "../../assets/images/cc.png";
import price_bg from "../../assets/images/price_bg.png";
import pricingCardBg from "../../assets/images/pricing_card_bg_f_m.png";

const pricingItems = [
  {
    title: "Shirts & Tops",
    desc: "Freshly cleaned & perfectly pressed",
    price: "$5.25",
    icon: <FaTshirt />,
  },

  {
    title: "Pants & Trousers",
    desc: "Professional garment care",
    price: "$10.45",
    icon: <FaUserTie />,
  },

  {
    title: "Suits & Jackets",
    desc: "Premium dry cleaning service",
    price: "$22.95",
    icon: <FaTag />,
  },
];
function PricingPreview() {
  return (
    <Box
      sx={{
        backgroundImage: {
          xs: `url(${pricingBgM})`,
          md: `url(${pricingBg})`,
        },

        backgroundSize: "cover",

        backgroundPosition: "center",

        backgroundRepeat: "no-repeat",

        py: {
          xs: 4,
          md: 6,
        },

        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xs: "column",
              lg: "row",
            },
            alignItems: "center",
            justifyContent: "space-between",
            gap: {
              xs: 5,
              lg: 8,
            },
          }}
        >
          {/* LEFT SIDE */}

          <Box
            sx={{
              width: {
                xs: "100%",
                lg: "36%",
              },

              position: "relative",

              zIndex: 2,
            }}
          >
            {/* PREMIUM BADGE */}

            <Box
              sx={{
                display: "inline-flex",

                alignItems: "center",

                gap: 1,

                px: 2.5,

                py: 1,

                borderRadius: "999px",

                background: "rgba(255,255,255,.78)",

                backdropFilter: "blur(18px)",

                border: "1px solid rgba(0,87,255,.08)",

                boxShadow: "0 10px 30px rgba(0,87,255,.08)",

                color: "#0057FF",

                fontWeight: 700,

                fontSize: {
                  xs: "8px",
                  md: "10px",
                },

                letterSpacing: "1px",

                textTransform: "uppercase",
              }}
            >
              ✦ Premium Pricing
            </Box>

            {/* HEADING */}

            <Typography
              sx={{
                mt: 2,

                fontWeight: 900,

                lineHeight: 1.05,

                letterSpacing: "-1px",

                fontSize: {
                  xs: "38px",
                  sm: "46px",
                  md: "56px",
                  lg: "56px",
                },
              }}
            >
              <Box
                component="span"
                sx={{
                  color: "#07122F",
                }}
              >
                Premium
              </Box>

              <Box
                component="span"
                sx={{
                  background: "linear-gradient(135deg,#0057ff,#2f8cff)",
                  WebkitBackgroundClip: "text",

                  WebkitTextFillColor: "transparent",
                }}
              >
                {" "}
                Care & Pricing
              </Box>
            </Typography>

            {/* DESCRIPTION */}

            <Typography
              sx={{
                mt: 2,

                // maxWidth: "540px",

                color: "#64748b",

                lineHeight: 1.9,

                fontSize: {
                  xs: "14px",
                  md: "16px",
                },
              }}
            >
              Enjoy expert cleaning, repairs, custom printing and specialty care
              services with fair pricing, exceptional craftsmanship and trusted
              quality for every item we handle.
            </Typography>

            {/* PREMIUM CHIPS */}

            <Box
              sx={{
                mt: 2,

                display: "flex",

                flexWrap: "wrap",

                gap: 1.2,
              }}
            >
              {[
                "✓ Free Pickup",
                "✓ Same Day",
                "✓ No Hidden Fees",
                "✓ Premium Care",
              ].map((item) => (
                <Box
                  key={item}
                  sx={{
                    px: 1.6,
                    py: 0.8,

                    fontSize: "12px",

                    borderRadius: "999px",

                    background: "rgba(255,255,255,.75)",

                    backdropFilter: "blur(15px)",

                    border: "1px solid rgba(0,87,255,.08)",

                    boxShadow: "0 8px 20px rgba(0,87,255,.06)",

                    color: "#12305f",

                    fontWeight: 600,
                  }}
                >
                  {item}
                </Box>
              ))}
            </Box>

            {/* TRUST INFO */}

            <Box
              sx={{
                mt: 4,

                display: "flex",

                flexWrap: "wrap",

                gap: 3,
              }}
            >
              <Box>
                <Typography
                  sx={{
                    color: "#0057FF",

                    fontWeight: 900,

                    fontSize: {
                      xs: "24px",
                      md: "42px",
                    },
                  }}
                >
                  1000+
                </Typography>

                <Typography
                  sx={{
                    color: "#64748b",

                    fontSize: "14px",
                  }}
                >
                  Happy Customers
                </Typography>
              </Box>

              <Box>
                <Typography
                  sx={{
                    color: "#0057FF",

                    fontWeight: 900,

                    fontSize: {
                      xs: "24px",
                      md: "42px",
                    },
                  }}
                >
                  10+
                </Typography>

                <Typography
                  sx={{
                    color: "#64748b",

                    fontSize: "14px",
                  }}
                >
                  Years Experience
                </Typography>
              </Box>
            </Box>

            {/* BUTTON */}

            <Button
              variant="contained"
              endIcon={<FaArrowRight />}
              sx={{
                mt: 3.5,

                px: 3.5,

                py: 1.2,

                minWidth: "240px",

                borderRadius: "999px",

                fontWeight: 700,

                fontSize: {
                  xs: "14px",
                  md: "15px",
                },

                textTransform: "none",

                background: "linear-gradient(135deg,#0057FF,#2F8CFF)",

                boxShadow: "0 12px 30px rgba(0,87,255,.25)",

                "&:hover": {
                  transform: "translateY(-2px)",
                },
              }}
              href="/pricing"
            >
              View Complete Pricing
            </Button>
          </Box>

          {/* RIGHT SIDE */}

          <Box
            sx={{
              width: {
                xs: "100%",
                lg: "60%",
              },

              display: "flex",

              flexWrap: "wrap",

              justifyContent: "center",

              gap: {
                xs: 2,
                md: 2.5,
                lg: 3,
              },
            }}
          >
            {pricingItems.map((item, index) => (
              <Box
                key={index}
                sx={{
                  width: {
                    xs: "100%",
                    sm: "48%",
                    lg: "30%",
                  },

                  minHeight: {
                    xs: 350,
                    md: 400,
                  },
                  position: "relative",

                  borderRadius: "28px",

                  overflow: "hidden",

                  backgroundImage: {
                    xs: `url(${pricingCardBg})`,
                    md: `url(${pricingCardBg})`,
                  },

                  backgroundSize: "cover",

                  backgroundPosition: "center",

                  border: "1px solid rgba(255,255,255,.85)",

                  backdropFilter: "blur(20px)",

                  boxShadow: "0 20px 60px rgba(0,87,255,.12)",

                  display: "flex",

                  flexDirection: "column",

                  alignItems: "center",

                  textAlign: "center",

                  p: {
                    xs: 2.2,
                    md: 3,
                  },

                  transition: ".35s",

                  "&:hover": {
                    transform: "translateY(-10px)",
                    boxShadow: "0 30px 80px rgba(0,87,255,.18)",
                  },

                  "&::before": {
                    content: '""',

                    position: "absolute",

                    left: 0,

                    top: 0,

                    bottom: 0,

                    width: "6px",

                    background: "linear-gradient(180deg,#0057FF,#59AFFF)",
                  },
                }}
              >
                {/* ICON */}

                <Box
                  sx={{
                    width: {
                      xs: 72,
                      md: 90,
                    },

                    height: {
                      xs: 72,
                      md: 90,
                    },

                    borderRadius: "50%",

                    background: "linear-gradient(135deg,#ffffff,#edf5ff)",

                    border: "1px solid rgba(0,87,255,.12)",

                    boxShadow: "0 15px 40px rgba(0,87,255,.10)",

                    display: "flex",

                    alignItems: "center",

                    justifyContent: "center",

                    color: "#0057FF",

                    fontSize: {
                      xs: "30px",
                      md: "38px",
                    },

                    mt: 1,
                  }}
                >
                  {item.icon}
                </Box>

                {/* TITLE */}

                <Typography
                  sx={{
                    mt: 2,

                    fontWeight: 800,

                    color: "#12305f",

                    lineHeight: 1.2,

                    fontSize: {
                      xs: "20px",
                      md: "24px",
                    },
                  }}
                >
                  {item.title}
                </Typography>

                {/* DESC */}

                <Typography
                  sx={{
                    mt: 1,

                    color: "#64748b",

                    lineHeight: 1.7,

                    maxWidth: "220px",

                    fontSize: {
                      xs: "13px",
                      md: "14px",
                    },
                  }}
                >
                  {item.desc}
                </Typography>

                {/* PRICE */}

                <Box
                  sx={{
                    mt: 3,

                    width: {
                      xs: 110,
                      md: 135,
                    },

                    height: {
                      xs: 110,
                      md: 135,
                    },

                    borderRadius: "50%",

                    // background: "linear-gradient(135deg,#ffffff,#eef6ff)",
                    backgroundImage: `url(${price_bg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",

                    border: "1px solid rgba(0,87,255,.10)",

                    // boxShadow: "0 15px 35px rgba(0,87,255,.08)",

                    display: "flex",

                    flexDirection: "column",

                    alignItems: "center",

                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#0057FF",
                      fontWeight: 600,
                      fontSize: {
                        xs: "12px",
                        md: "14px",
                      },
                    }}
                  >
                    From
                  </Typography>

                  <Typography
                    sx={{
                      color: "#0057FF",

                      fontWeight: 900,

                      lineHeight: 1,

                      fontSize: {
                        xs: "38px",
                        md: "42px",
                      },
                    }}
                  >
                    {item.price}
                  </Typography>
                </Box>

                {/* BUTTON */}

                <Button
                  sx={{
                    mt: 1,

                    px: 3,

                    py: 1,

                    borderRadius: "50px",

                    fontWeight: 700,

                    fontSize: {
                      xs: "12px",
                      md: "13px",
                    },

                    color: "#fff",

                    background: "linear-gradient(135deg,#0057FF,#2F8CFF)",

                    boxShadow: "0 12px 25px rgba(0,87,255,.25)",

                    "&:hover": {
                      background: "linear-gradient(135deg,#0047d4,#2684ff)",
                    },
                  }}
                >
                  PERFECT CARE
                </Button>
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default PricingPreview;
